import { render, staticRenderFns } from "./PackageComplete.vue?vue&type=template&id=448af185&scoped=true"
import script from "./PackageComplete.vue?vue&type=script&lang=js"
export * from "./PackageComplete.vue?vue&type=script&lang=js"
import style0 from "./PackageComplete.vue?vue&type=style&index=0&id=448af185&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448af185",
  null
  
)

export default component.exports